const FEATURE_FLAG_PREFIX = 'ff:';
const DEFAULT_EXPIRY_MS = 1 * 60 * 60 * 1000; // 1 hours

const FEATURE_NAMES = {
  DROP_SHIP: 'dropship'
}

// FEATURE_FLAG_MODULES is an enum-like object that defines the default behavior of feature flags per module.
// In the future, these values might be fetched from an API.
// Initially, we planned to use environment variables, but `process.env` is only accessible in `.vue` files,
// and we also need access to these settings in other contexts (e.g., router configuration).
// This constant serves as a central configuration and works well as a substitute for env-based flags.

// Possible values:
// - null  → Respect user-defined flags via query params or session storage.
// - true  → Force the feature flag to be ON, ignoring all other checks.
// - false → Force the feature flag to be OFF, ignoring all other checks.

const FEATURE_FLAG_MODULES = {
  dropship: true
};


export { FEATURE_FLAG_PREFIX, DEFAULT_EXPIRY_MS, FEATURE_NAMES, FEATURE_FLAG_MODULES };